<script>
  import { mapGetters } from 'vuex';
  import FilterItem from '@/components/MainFilter/FilterItem';
  import VInput from '@/components/Common/VInput';
  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/antd.css';
  import Scrollbar from 'smooth-scrollbar';
  import cookies from 'vue-cookies';
  import _ from 'lodash';

  const SETTINGS_SLIDER = {
    dotSize: 16,
    dotStyle: {
      backgroundColor: '#eff0f3',
      border: '5px solid #95CA51',
    },
    railStyle: {
      backgroundColor: '#eff0f3',
    },
    processStyle: {
      border: '1px solid #95CA51',
      backgroundColor: '#95CA51',
    },
  };

  export default {
    name: 'FilterComponent',
    components: {
      FilterItem,
      VInput,
      VueSlider,
    },
    props: {
      filterData: {
        type: Object,
        default: () => ({}),
      },
      filterPageData: {
        type: Object,
        default: () => ({}),
      },
      typePage: {
        type: String,
        required: true,
      },
      isLanding: {
        type: Boolean,
        default: false,
      },
    },
    SETTINGS_SLIDER,
    cookies,
    data() {
      return {
        currentFilterData: this.filterData,
        filters: {
          hot_offer: null,
          created_at: null,
          brands: [],
          models: [],
          bodies: [],
          fuel: [],
          kpp: [],
          power: {
            min: null,
            max: null,
          },
          mileage: {
            min: null,
            max: null,
          },
          year: {
            min: null,
            max: null,
          },
          price: {
            min: null,
            max: null,
          },
          dealers: [],
        },
        sliders: {
          power: [null, null],
          mileage: [null, null],
          year: [null, null],
          price: [null, null],
        },
        firstUpload: true,
        openedFilter: false,
        isNewCarsPage: window.location.pathname.includes('/cars/new'),
      };
    },
    watch: {
      filterParams() {
        this.currentFilterData = this.filterParams;
      },
      waitForRequestFilterParams(value) {
        if (value) {
          this.removeUnwantedElement();

          this.$emit('change-filters', this.filters);
          this.$emit('update-filter');
        }
      },
      selectedData() {
        if (Object.keys(this.selectedData).length > 0) {
          this.selectionPrimaryData(this.selectedData);
          this.$emit('change-filters', this.filters);
          setTimeout(() => {
            this.$emit('update-filter');
          }, 0);
        }
      },
    },
    created() {
      this.$nextTick(() => {
        document.querySelectorAll('.scrollbar').forEach(element => {
          Scrollbar.init(element, {
            alwaysShowTracks: true,
          });
        });
      });

      this.updateFiltersFromGetParams();

      if (Object.keys(this.filterPageData).length > 0) {
        this.selectionPrimaryData(this.filterPageData);
        this.$emit('change-filters', this.filters);
        setTimeout(() => {
          this.$emit('update-filter');
        }, 0);
      }

      this.insertDefaultParams();
    },
    computed: {
      ...mapGetters({
        filterParams: 'Filter/filterParams',
        waitForRequestFilterParams: 'Filter/waitForRequestFilterParams',
        selectedData: 'Filter/selectedData',
      }),
    },
    methods: {
      getParams() {
        const query = window.location.search.replace('?', '').split('&');
        let params = {};

        if (window.location.search !== '') {
          query.forEach(element => {
            if (element.includes('%5B%5D')) {
              if (!params[element.split('=')[0].replace('%5B%5D', '')]) {
                params[element.split('=')[0].replace('%5B%5D', '')] = [];
              }
              params[element.split('=')[0].replace('%5B%5D', '')].push(
                element.split('=')[1],
              );
            } else {
              params[element.split('=')[0]] = element.split('=')[1];
            }
          });
        }
        return params;
      },
      updateFiltersFromGetParams() {
        if (window.location.search !== '') {
          Object.entries(this.getParams()).forEach(([key, value]) => {
            if (value) {
              if (this.filters && typeof value === 'string') {
                if (key === 'hot_offer') {
                  this.filters[key] = this.filterData[key];
                } else if (key === 'created_at') {
                  this.filters[key] = this.filterData[key];
                } else if (key.includes('min')) {
                  if (this.filters[key.replace('_min', '')])
                    this.filters[key.replace('_min', '')].min = value;
                  if (this.sliders[key.replace('_min', '')])
                    this.sliders[key.replace('_min', '')][0] = value;
                } else if (key.includes('max')) {
                  if (this.filters[key.replace('_max', '')])
                    this.filters[key.replace('_max', '')].max = value;
                  if (this.sliders[key.replace('_max', '')])
                    this.sliders[key.replace('_max', '')][1] = value;
                }
              } else {
                value.forEach(item => {
                  if (!this.filters[key]) {
                    this.filters[key] = [];
                  }

                  const currentItem = this.filterData[key].find(
                    e => e.id === Number(item),
                  );
                  if (currentItem) {
                    this.filters[key].push(currentItem);
                  }
                });
              }
            }
          });
        }

        this.$emit('change-filters', this.filters);
      },
      insertDefaultParams() {
        Object.keys(this.sliders).forEach(name => {
          if (!this.filters[name].min && this.filterData[name]?.min >= 0) {
            this.filters[name].min = this.filterData[name].min;
            this.sliders[name][0] = this.filterData[name].min;
          }

          if (!this.filters[name].max && this.filterData[name]?.max >= 0) {
            this.filters[name].max = this.filterData[name].max;
            this.sliders[name][1] = this.filterData[name].max;
          }
        });
      },
      removeUnwantedElement() {
        Object.keys(this.filters).forEach(name => {
          if (this.filters[name] instanceof Array) {
            let ids = [];
            this.currentFilterData[name].forEach(item => {
              ids.push(item.id);
            });

            this.filters[name] = this.filters[name].filter(e =>
              ids.includes(e.id),
            );
          }
        });
      },
      selectionPrimaryData(data) {
        if (
          data['brand'] >= 0 &&
          !this.filters.brands.some(
            e =>
              e.id === data['brand'] &&
              this.filterData.allBrands.some(e => e.id === data['brand']),
          )
        ) {
          this.filters.brands.push(
            this.filterData.allBrands.find(e => e.id === data['brand']),
          );
        }
        if (
          data['model'] >= 0 &&
          !this.filters.models.some(e => e.id === data['model']) &&
          this.filterData.models_all.some(e => e.id === data['model'])
        ) {
          this.filters.models.push(
            this.filterData.models_all.find(e => e.id === data['model']),
          );
          this.filterData.models.push(
            this.filterData.models_all.find(e => e.id === data['model']),
          );
        }
      },
      getGroups(name) {
        let groups = [];
        this.currentFilterData[name].forEach(element => {
          if (element.group_name && !groups.includes(element.group_name)) {
            groups.push(element.group_name);
          }
        });
        return groups;
      },
      addingToObject(name) {
        const object = {
          name: name,
          group: true,
        };
        return object;
      },
      isItemSelected(item, name) {
        if (this.filters[name]) {
          if (name === 'hot_offer') {
            return !!this.filters[name];
          } else if (name === 'created_at') {
            return !!this.filters[name];
          } else if (item.group) {
            const itemsWithGroup = this.currentFilterData[name].filter(
              e => e.group_name === item.name,
            );
            const filtersItemsWithGroup = this.filters[name].filter(
              e => e.group_name === item.name,
            );

            return itemsWithGroup.length === filtersItemsWithGroup.length;
          } else {
            return this.filters[name].some(e => e.id === item.id);
          }
        } else {
          return false;
        }
      },
      itemSelection(item, checked, name) {
        if (name === 'hot_offer') {
          this.filters[name] = !!this.filters[name] ? null : item;
        } else if (name === 'created_at') {
          this.filters[name] = !!this.filters[name] ? null : item;
        } else {
          if (this.filters[name]?.find(e => e.id === item.id)) {
            this.filters[name] = this.filters[name].filter(e => e.id !== item.id);
          } else {
            if (item.group) {
              const itemsWithGroup = this.currentFilterData[name].filter(
                e => e.group_name === item.name,
              );
              const itemsWithoutGroup = this.filters[name].filter(
                e => !e.group_name,
              );

              if (checked) {
                this.filters[name] = itemsWithoutGroup;
              } else {
                this.filters[name] = itemsWithGroup.concat(itemsWithoutGroup);
              }
            } else {
              if (!this.filters[name]) {
                this.filters[name] = [];
              }
              this.filters[name].push(item);
            }
          }
        }
        if (name === 'brands') {
          // this.$emit('uploads-data', undefined, true);
        } else {
          // this.$emit('change-filters', this.filters);
          // this.$emit('update-filter');
        }
      },
      updateFilterDebounce: _.debounce(function () {

        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      }, 700),
      changeInputSlider(name) {
        this.sliders[name] = [this.filters[name].min, this.filters[name].max];
        this.updateFilterDebounce();
      },
      changeSlider: _.debounce(function () {
        Object.keys(this.sliders).forEach(name => {
          const data = {
            min: this.sliders[name][0],
            max: this.sliders[name][1],
          };

          this.filters[name] = data;
        });
        this.updateFilterDebounce();
      }, 700),
      resetAllFilter() {
        Object.keys(this.filters).forEach(name => {
          if (this.filters[name]?.min >= 0 && this.filters[name]?.max >= 0) {
            this.filters[name] = this.filterData[name];
            this.sliders[name] = [
              this.filterData[name]?.min,
              this.filterData[name]?.max,
            ];
          } else if (name === 'hot_offer') {
            this.filters[name] = null;
          } else if (name === 'created_at') {
            this.filters[name] = null;
          } else {
            this.filters[name] = [];
          }
        });
        this.selectionPrimaryData(this.filterPageData);

        this.$emit('change-filters', this.filters);
        this.$emit('reset-all-filter');
      },
      showFilter() {
        this.openedFilter = !this.openedFilter;

        if (!this.openedFilter) {
          window.scrollBy({
            top:
              document.querySelector('#filter-cars').getBoundingClientRect().top -
              50,
            behavior: 'smooth',
          });
        }
      },
    },
  };
</script>

<template>
  <div class="flex-shrink lg:min-w-[280px] w-full lg:w-[280px]">
    <button
      class="button button_green button_big w-full lg:hidden mb-5"
      @click="showFilter"
    >
      {{ openedFilter ? 'Показать машины' : 'Фильтр' }}
    </button>
    <div
      class="lg:block rounded-big-brand mb-5 lg:mb-0 lg:mr-6 2xl:mr-8 bg-white"
      :class="{ hidden: !openedFilter }"
    >
      <div>
        <div
          v-if="currentFilterData?.hot_offer"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <filter-item
            :item="currentFilterData.hot_offer"
            name="hot_offer"
            :is-item-selected="isItemSelected(currentFilterData.hot_offer, 'hot_offer')
              "
            @on-item-click="itemSelection"
          >
            <img class="w-6 mr-1" src="/public/images/fire-offer.png" alt="" />
          </filter-item>
        </div>
        <div
          v-if="currentFilterData?.created_at"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <filter-item
            :item="currentFilterData.created_at"
            name="created_at"
            :is-item-selected="isItemSelected(currentFilterData.created_at, 'created_at')
              "
            @on-item-click="itemSelection"
          >
            <img
              class="w-6 mr-1"
              src="/public/images/new_created_at.png"
              alt=""
            />
          </filter-item>
        </div>

        <div
          v-if="currentFilterData?.brands"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">Марка</div>

          <div class="max-h-[136px] scrollbar">
            <div class="mb-1">
              <div
                v-for="item in currentFilterData.brands"
                :key="item.id"
                class="flex items-center justify-between mb-2 last:mb-0"
              >
                <filter-item
                  :item="item"
                  name="brands"
                  :is-item-selected="isItemSelected(item, 'brands')"
                  @on-item-click="itemSelection"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="currentFilterData?.models"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">Модель</div>

          <div class="max-h-[136px] scrollbar">
            <div class="mb-1">
              <div
                v-for="item in currentFilterData.models"
                :key="item.id"
                class="flex items-center justify-between mb-2 last:mb-0"
              >
                <filter-item
                  :item="item"
                  name="models"
                  :is-item-selected="isItemSelected(item, 'models')"
                  @on-item-click="itemSelection"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="currentFilterData?.bodies"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">Кузов</div>
          <div>
            <div
              v-for="item in currentFilterData.bodies"
              :key="item.id"
              class="flex items-center justify-between mb-2 last:mb-0"
            >
              <filter-item
                :item="item"
                name="bodies"
                :is-item-selected="isItemSelected(item, 'bodies')"
                @on-item-click="itemSelection"
              />
            </div>
          </div>
        </div>

        <div
          v-if="currentFilterData?.fuel"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">Двигатель</div>
          <div>
            <div
              v-for="item in currentFilterData.fuel"
              :key="item.id"
              class="flex items-center justify-between mb-2 last:mb-0"
            >
              <filter-item
                :item="item"
                name="fuel"
                :is-item-selected="isItemSelected(item, 'fuel')"
                @on-item-click="itemSelection"
              />
            </div>
          </div>
        </div>

        <div
          v-if="currentFilterData?.kpp"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">КПП</div>
          <div>
            <div v-for="item in currentFilterData.kpp" :key="item.id">
              <div
                v-if="!item.group_name"
                class="flex items-center justify-between mb-2"
              >
                <filter-item
                  :item="item"
                  name="kpp"
                  :is-item-selected="isItemSelected(item, 'kpp')"
                  @on-item-click="itemSelection"
                />
              </div>
            </div>

            <template v-if="getGroups('kpp').length > 0" class="-mb-2">
              <div v-for="(group, index) in getGroups('kpp')" :key="index">
                <div class="flex items-center justify-between mb-2">
                  <filter-item
                    :item="addingToObject(group)"
                    name="kpp"
                    :is-item-selected="isItemSelected(addingToObject(group), 'kpp')
                      "
                    @on-item-click="itemSelection"
                  />
                </div>

                <div v-for="item in currentFilterData.kpp" :key="item.id">
                  <div
                    v-if="item.group_name"
                    class="flex items-center justify-between mb-2 pl-4"
                  >
                    <filter-item
                      :item="item"
                      name="kpp"
                      :is-item-selected="isItemSelected(item, 'kpp')"
                      @on-item-click="itemSelection"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div
          v-if="currentFilterData?.power"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">Мощность двигателя</div>
          <div>
            <div class="relative flex items-center space-x-2">
              <v-input
                v-model="filters.power.min"
                theme="gray"
                format="number"
                class="bg-gray-200 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" л.с."
                :min="currentFilterData.power.min"
                :max="currentFilterData.power.max"
                :followInput="false"
                :lazy="true"
                @change="changeInputSlider('power')"
                @keyup="changeInputSlider('power')"
              />
              <div class="relative w-3.5 h-px bg-gray-400"></div>
              <v-input
                v-model="filters.power.max"
                theme="gray"
                format="number"
                class="bg-gray-200 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" л.с."
                :min="currentFilterData.power.min"
                :max="currentFilterData.power.max"
                :followInput="false"
                @change="changeInputSlider('power')"
                @keyup="changeInputSlider('power')"
              />
            </div>
            <vue-slider
              v-model="sliders.power"
              :min="currentFilterData.power.min"
              :max="currentFilterData.power.max"
              :tooltip="'none'"
              :interval="1"
              :dot-size="$options.SETTINGS_SLIDER.dotSize"
              :dot-style="$options.SETTINGS_SLIDER.dotStyle"
              :rail-style="$options.SETTINGS_SLIDER.railStyle"
              :process-style="$options.SETTINGS_SLIDER.processStyle"
              class="mt-2 mx-2"
              :enableCross="false"
              @change="changeSlider"
            />
          </div>
        </div>

        <div
          v-if="currentFilterData?.mileage"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">Пробег</div>
          <div>
            <div class="relative flex items-center space-x-2">
              <v-input
                v-model="filters.mileage.min"
                theme="gray"
                format="number"
                class="bg-gray-200 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" км"
                :min="currentFilterData.mileage.min"
                :max="currentFilterData.mileage.max"
                :followInput="false"
                @change="changeInputSlider('mileage')"
                @keyup="changeInputSlider('mileage')"
              />
              <div class="relative w-3.5 h-px bg-gray-400"></div>
              <v-input
                v-model="filters.mileage.max"
                theme="gray"
                format="number"
                class="bg-gray-200 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" км"
                :min="currentFilterData.mileage.min"
                :max="currentFilterData.mileage.max"
                :followInput="false"
                @change="changeInputSlider('mileage')"
                @keyup="changeInputSlider('mileage')"
              />
            </div>
            <vue-slider
              v-model="sliders.mileage"
              :min="currentFilterData.mileage.min"
              :max="currentFilterData.mileage.max"
              :tooltip="'none'"
              :interval="1"
              :dot-size="$options.SETTINGS_SLIDER.dotSize"
              :dot-style="$options.SETTINGS_SLIDER.dotStyle"
              :rail-style="$options.SETTINGS_SLIDER.railStyle"
              :process-style="$options.SETTINGS_SLIDER.processStyle"
              class="mt-2 mx-2"
              :enableCross="false"
              @change="changeSlider"
            />
          </div>
        </div>

        <div
          v-if="currentFilterData?.year"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">Год выпуска</div>
          <div>
            <div class="relative flex items-center space-x-2">
              <v-input
                v-model="filters.year.min"
                theme="gray"
                format="number"
                class="bg-gray-200 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" г."
                :min="currentFilterData.year.min"
                :max="currentFilterData.year.max"
                :followInput="false"
                @change="changeInputSlider('year')"
                @keyup="changeInputSlider('year')"
              />
              <div class="relative w-3.5 h-px bg-gray-400"></div>
              <v-input
                v-model="filters.year.max"
                theme="gray"
                format="number"
                class="bg-gray-200 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" г."
                :min="currentFilterData.year.min"
                :max="currentFilterData.year.max"
                :followInput="false"
                @change="changeInputSlider('year')"
                @keyup="changeInputSlider('year')"
              />
            </div>
            <vue-slider
              v-model="sliders.year"
              :min="currentFilterData.year.min"
              :max="currentFilterData.year.max"
              :tooltip="'none'"
              :interval="1"
              :dot-size="$options.SETTINGS_SLIDER.dotSize"
              :dot-style="$options.SETTINGS_SLIDER.dotStyle"
              :rail-style="$options.SETTINGS_SLIDER.railStyle"
              :process-style="$options.SETTINGS_SLIDER.processStyle"
              class="mt-2 mx-2"
              :enableCross="false"
              @change="changeSlider"
            />
          </div>
        </div>

        <div
          v-if="currentFilterData?.price"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">Цена</div>
          <div>
            <div class="relative flex items-center space-x-2">
              <v-input
                v-model="filters.price.min"
                theme="gray"
                format="price"
                class="bg-gray-200 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" руб."
                :min="currentFilterData.price.min"
                :max="currentFilterData.price.max"
                :followInput="false"
                @change="changeInputSlider('price')"
                @keyup="changeInputSlider('price')"
              />
              <div class="relative w-3.5 h-px bg-gray-400"></div>
              <v-input
                v-model="filters.price.max"
                theme="gray"
                format="price"
                class="bg-gray-200 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" руб."
                :min="currentFilterData.price.min"
                :max="currentFilterData.price.max"
                :followInput="false"
                @change="changeInputSlider('price')"
                @keyup="changeInputSlider('price')"
              />
            </div>
            <vue-slider
              v-model="sliders.price"
              :min="currentFilterData.price.min"
              :max="currentFilterData.price.max"
              :tooltip="'none'"
              :interval="1"
              :dot-size="$options.SETTINGS_SLIDER.dotSize"
              :dot-style="$options.SETTINGS_SLIDER.dotStyle"
              :rail-style="$options.SETTINGS_SLIDER.railStyle"
              :process-style="$options.SETTINGS_SLIDER.processStyle"
              class="mt-2 mx-2"
              :enableCross="false"
              @change="changeSlider"
            />
          </div>
        </div>

        <div
          v-if="currentFilterData?.dealers"
          class="p-5 border-b last:border-b-0 border-gray-200"
        >
          <div class="font-medium uppercase mb-3">Дилерский центр</div>
          <div>
            <!--noindex-->
            <div
              v-for="item in currentFilterData.dealers"
              :key="item.id"
              class="flex items-center justify-between mb-2 last:mb-0"
            >
              <filter-item
                :item="item"
                name="dealers"
                :is-item-selected="isItemSelected(item, 'dealers')"
                @on-item-click="itemSelection"
              />
            </div>
            <!--/noindex-->
          </div>
        </div>
      </div>

      <div class="p-5">
        <button
          class="button button_green button_big w-full lg:hidden mb-3"
          @click="showFilter"
        >
          Показать машины
        </button>

        <button
          class="button button_gray-dark button_big w-full"
          @click="resetAllFilter"
        >
          Очистить фильтры
        </button>
      </div>

      <div
        v-if="typePage !== 'stock' && !isLanding && !isNewCarsPage"
        class="p-5"
      >
        <p class="text-xs">
          * Доставка осуществляется в города присутствия ДЦ сети ООО
          «ПЛ-ИНФОРМ», услуга является платной, подробности уточняйте у
          менеджеров отдела продаж
        </p>
      </div>
    </div>
  </div>
</template>
